import {alt} from 'epic-react-common';
import generateWithAsyncActions from 'epic-alt-utils';

/**
 * RedeemActions
 */

export default generateWithAsyncActions(
  alt,
  ['validateCode', 'redeemCode', 'clearEntitlementsFromSession'],
  ['resetFlow', 'setNextStage', 'setCurrentStage', 'requestLogin', 'requestRegister']
);
